/* eslint-disable no-fallthrough */
import React, { useEffect, useState } from 'react'
import GenericFormComponent from '../../../genericComponents/forms/GenericFormComponent'
import GenericCustomButton from '../../../genericComponents/GenericCustomButton'
import Icons from '../../../assets/icons';
import { Radio } from 'antd';
import ProcDashBottomCards from './ProcDashBottomCards';
import { dispatchHandler } from '../../../helper/apiHelperFunctions';
import { useDispatch } from 'react-redux';
import '../../../styles/stylesheets/digiProc/ProcDashboard.scss'
import LanguageTranslator from '../../../locals/LanguageTranslator';
import { getPermissionKey } from '../../../helper/permissions';
import { openDB } from 'idb';
import { getDataStorageKey } from '../../../helper/helperTableFunctions';

const FILTERS = [
    {
        value: "Site",
        key: "name1",
        code: "code",
        entity: "site",
        headerKeys: {
            'name1': { value: 'Site' },
            'code': { value: 'Code' }
        },
        itemKeys: {
            'name1': ['name1'],
            'code': ['code']
        },
    },
    {
        value: "Vendor",
        key: "slname",
        code: "slcode",
        entity: "vendor",
        headerKeys: {
            'slname': { value: 'Vendor' },
            'slcode': { value: 'Code' }
        },
        itemKeys: {
            'slname': ['slname'],
            'slcode': ['slcode']
        }
    }
]

const PRIMARY_FILTERS = [
    {
        value: "Division",
        key: "hl1_name",
        code: "hl1_code",
        entity: "item",
    },
    {
        value: "Section",
        key: "hl2_name",
        code: "hl2_code",
        entity: "item",
    },
    {
        value: "Department",
        key: "hl3_name",
        code: "hl3_code",
        entity: "item",
    },
    {
        value: "Article Name",
        key: "hl4_name",
        code: "hl4_code",
        entity: "item",
    }
]

const ProcurementDashboard = (props) => {
    const dispatch = useDispatch()
    const [inputData, setInputData] = useState({})
    const [errorData, setErrorData] = useState({})
    const [procDashboardType, setProcDashboardType] = useState('pi')
    const [toggleChanged, setToggleChanged] = useState(false)
    const [isdisable, setIsDisable] = useState(true)
    const [masterDbResponse, setMasterDbResponse] = useState({});

    useEffect(() => {
        updateMasterDbResponse()
    }, []);

    // Function: To update the master db response
    const updateMasterDbResponse = async () => {
        const db = await openDB(getDataStorageKey?.(), 1);
        let updatedMasterDbResponse = {};
        ["DYNAMIC_ITEM_CONFIG", "DYNAMIC_SITE_CONFIG"]?.map(async key => {
            let response = await db.get("MASTER_DB_DROPDOWN", key) || [];
            updatedMasterDbResponse[key] = response;
        })
        setMasterDbResponse(updatedMasterDbResponse)
        db?.close();
    }

    const handleApplyFilter = (state = inputData) => {
        let payload = {
            isPO: procDashboardType === "pi" ? false : true,
            fromDate: state?.dateRange?.[0]?.format('YYYY-MM-DD') || '',
            toDate: state?.dateRange?.[1]?.format('YYYY-MM-DD') || '',
            expireDays: "",
            siteCode: state?.name1?.name1 || '',
            slCode: state?.slname?.slname || '',
            hl1Code: state?.hl1_name?.hl1_code || "",
            hl2Code: state?.hl2_name?.hl2_code || "",
            hl3Code: state?.hl3_name?.hl3_code || "",
            hl4Code: state?.hl4_name?.hl4_code || "",
            isToggle: toggleChanged === true ? true : false,
        }

        dispatchHandler(dispatch, 'piDashBottomRequest', payload, getPermissionKey("dashboard", "procurement", "view"))
    }


    const handleChange = (type, data) => {
        let { value, state } = data;
        switch (type) {
            case 'dateRange':
            case 'filterChange':
                setIsDisable(false)
                break;

            default:
                break;
        }

        if(!value){
            handleApplyFilter(state)
        }
    }

    const getOtherData = (filter, filterData = {}) => {
        let otherData = {};
        const DROPDOWN_TYPE = "DYNAMIC_ITEM_CONFIG";
        if (DROPDOWN_TYPE) {
            let response = masterDbResponse?.[DROPDOWN_TYPE] || [];
            Object.keys(filterData || {})?.map(key => {
                if (Object.keys(filterData?.[key] || {})?.length > 0) {
                    Object.keys(filterData?.[key] || {})?.map(innerKey => {
                        if (key != filter?.key && filter?.["entity"]) {
                            if (response?.includes(key)) {
                                if(Object.keys(filterData?.[key] || {})?.length > 0) {
                                    otherData[key] = [filterData?.[key]?.[key]];
                                }
                            }
                        }
                    })
                }
                
            })
        }
        return otherData;
    }

    const provideInputs = () => {
        let inputFieldsData = [
            { key: "dateRange", type: "range", placeholder: ['Start Date', 'End Date'], onChange: (value, state) => handleChange('dateRange',  {
                value : value,
                state : state,
            } ) },]
        inputFieldsData.push(...FILTERS.map((config) => {
            return {
                key: config?.key,
                iconRight: <Icons.DownArrowFilled />,
                modalMainClass: "use-as-generic-dropdown",
                placeholder: `${config?.value}`,
                type: 'dropdown',
                value: inputData?.[config?.key],
                inputProps: () => ({
                    search: {
                        placeholder: `Search ${config?.value}`,
                    },
                    viewDataType: "table-view",
                    api: {
                        reduxState: 'generalStore',
                        apiName: 'getSearchFilters',
                        apiPayload: (params) => {
                            return {
                                "entity": config?.entity,
                                "key": config.key,
                                "code": config?.code,
                                "search": params?.currentSearch || "",
                                "searchBy": params.searchFilter || "CONTAINS",
                                "pageNo": params?.currentPage || 1,
                                "moduleName": "",
                                "other_data": {},
                                "columnName": {}
                            }
                        },
                        getMaxPage: (states, functions, response) => Number(response?.resource?.maxPage || ""),
                    },
                    getListData: (response) => {
                        switch (config.key) {
                            default: return response?.resource?.searchResultNew?.map(data => ({ [config.key]: data[config.key], ...data }))
                        }
                    },
                    headerKeys: config.headerKeys ?? {
                        [config.key]: { value: [config.value] },
                    },
                    itemKeys: config.itemKeys ?? {
                        [config.key]: [config.key],
                    }
                }),
            }
        }))

        inputFieldsData.push(...PRIMARY_FILTERS.map((config) => {
            return {
                key: config?.key,
                iconRight: <Icons.DownArrowFilled />,
                viewDataType: "table-view",
                modalMainClass: "use-as-generic-dropdown",
                placeholder: `Select ${config?.value}`,
                type: 'dropdown',
                value: inputData?.[config?.key],
                // onChange: (data) => handleChange(config?.key, data),
                inputProps: () => ({
                    viewDataType: "table-view",
                    search: {
                        placeholder: `Search ${config?.value}`,
                    },
                    api: {
                        reduxState: 'generalStore',
                        apiName: 'getSearchFilters',
                        apiPayload: (params) => {
                            return {
                                "entity": config?.entity,
                                "key": config.key,
                                "code": config?.code,
                                "search": params?.currentSearch || "",
                                "searchBy": params.searchFilter || "CONTAINS",
                                "pageNo": params?.currentPage || 1,
                                "moduleName": "",
                                "other_data": getOtherData(config, inputData),
                                "columnName": {}
                            }
                        },
                        getMaxPage: (states, functions, response) => Number(response?.resource?.maxPage || ""),
                    },
                    getListData: (response) => {
                        switch (config.uniqueKey) {
                            default: return response?.resource?.searchResultNew?.map(data => ({ [config.key]: data[config.key], ...data }))
                        }
                    },
                    headerKeys: {
                        [config.key]: { value: [config.value] },
                    },
                    itemKeys: {
                        [config.key]: [config.key],
                    }
                }),
            }
        }))
        return inputFieldsData
    }

    const handleProcType = (data) => {
        setProcDashboardType(data?.target?.value)
        setToggleChanged(true)
    }

    const handleClearFilters = () => {
        setInputData({})
        setIsDisable(true)
        handleApplyFilter({})
    }

    // Function to render the primary filters data
    const renderPrimaryFilters = () => {
        return (
            <>
                <Radio.Group value={procDashboardType} onChange={handleProcType}>
                    <Radio.Button value={"pi"}><LanguageTranslator>PI</LanguageTranslator></Radio.Button>
                    <Radio.Button value={"po"}><LanguageTranslator>PO</LanguageTranslator></Radio.Button>
                </Radio.Group>
                <GenericFormComponent
                    rowInput={{
                        rowType: "singleRow",
                        availableInputs: provideInputs(),
                        inputState: { ...inputData },
                        inputStateChangeFunction: (data) => {
                            setInputData(data);
                        },
                        errorData: { ...errorData },
                        updateErrorData: (data) => {
                            setErrorData(data);
                        },
                        rowRightExtras: <React.Fragment>
                            <div className='gfbi-btns'>
                                <GenericCustomButton
                                    label='Apply Filter'
                                    type='primary'
                                    onClick={() => handleApplyFilter()}
                                    disabled={isdisable}

                                />
                                <GenericCustomButton
                                    label="Clear All"
                                    type="default"
                                    onClick={handleClearFilters}
                                    disabled={isdisable}
                                />
                            </div>
                        </React.Fragment>,
                    }}
                    availableDocument={props.availableDocument || null}
                />
            </>
        )
    }

    let startDate = inputData?.dateRange?.[0]?.format('YYYY-MM-DD') || '';
    let endDate = inputData?.dateRange?.[1]?.format('YYYY-MM-DD') || '';

    let filter = {
        ...(startDate && endDate) ?
            (procDashboardType === 'pi' ?
                { indentDate: startDate + '|' + endDate } :
                { createdTime: startDate + '|' + endDate })
            : undefined,
            siteName: inputData?.name1?.name1 || undefined,
        slName: inputData?.slname?.slname || undefined,
        siteCode: inputData?.name1?.code || undefined
    }
    let filterItems = {
        hl1Name: inputData?.hl1_name?.hl1_name || undefined,
        hl2Name: inputData?.hl2_name?.hl2_name || undefined,
        hl3Name: inputData?.hl3_name?.hl3_name || undefined,
        hl4Name: inputData?.hl4_name?.hl4_name || undefined,
    }
    Object.keys(filter || {})?.map((key) => {
        if (!filter?.[key]) {
            delete filter[key]
        }
    })
    Object.keys(filterItems || {})?.map((key) => {
        if (!filterItems?.[key]) {
            delete filterItems[key]
        }
    })

    return (
        <div className="proc-dashboard">
            {renderPrimaryFilters()}
            <ProcDashBottomCards filterItems={filterItems} filter={filter} procDashboardType={procDashboardType} toggleChanged={toggleChanged} />
        </div>
    )
}

export default ProcurementDashboard